export default "__VITE_ASSET__BvfAfdm0__"